import { useState } from "react";
import { FiMinus, FiPlus } from "react-icons/fi";
import { useBreakpoint } from "../../hooks";
import ChristmasLights from "../../images/services/christmas-lights.jpg";
import GutterCleanout from "../../images/services/gutter-cleanout.jpg";
import LawnMowing from "../../images/services/lawn-mowing.jpeg";
import ConcreteWashing from "../../images/services/concrete-washing.png";
import HouseWashing from "../../images/services/house-washing.png";
import RoofWashing from "../../images/services/roof-washing2.png";
import Mulching from "../../images/services/mulching.jpg";

const services = [
  {
    title: "Lawn Mowing",
    image: LawnMowing,
    description:
      "My lawn mowing service includes the mowing and weedwackinging of your property. Whatever caters to your lawn's needs best, I'm able to schedule weekly or bi-weekly mowing. I also offer a one time mowing option.",
  },
  {
    title: "House Washing",
    image: HouseWashing,
    description:
      "When the sun does not hit a certain side of your house, algae and mold can grow and spread across the exterior of your house. The soft wash system I use sprays the right soaps to kill the algae without damaging the siding.",
  },
  {
    title: "Roof Washing",
    image: RoofWashing,
    description:
      "Black streaks on your roof are caused by hard algae that stain your roof and in time can eat away at the shingles. My soft wash system protects the longevity of your roof and gets rid of the harmful black lines.",
  },
  {
    title: "Concrete Washing",
    image: ConcreteWashing,
    description:
      "Driveways see a lot of activity and because of this, dirt, mold and algae are inevitably going to build up and take away from your home's curb appeal. Luke’s Lawns cleans the driveway with a high pressure surface cleaner which will leave your driveway or other concrete looking brand new.",
  },
  {
    title: "Gutter Clean Out",
    image: GutterCleanout,
    description:
      "Throughout the year your gutters collect a lot of debris especially in the spring and fall. Don’t worry yourself with getting on a ladder and cleaning them out - leave it to me!",
  },
  {
    title: "Christmas Light Installation",
    image: ChristmasLights,
    description:
      "I provide professional grade Christmas light installation. I will custom order the lights to fit your house. When I install Christmas lights I put them up, service them throughout the season, and take them down when you desire.",
  },
  {
    title: "More Services",
    image: Mulching,
    description: (
      <div>
        <ul>
          <li>Leaf clean up</li>
          <li>Brush removal</li>
          <li>Hedge trimming</li>
          <li>Spring / Fall clean up</li>
          <li>Mulching</li>
          <li>Snow blowing</li>
        </ul>
        <p>
          Still don't see a service you're looking for? Give me a call for a
          consultation of your project.
        </p>
      </div>
    ),
  },
];

export const Services = () => {
  const { isMaxWidth } = useBreakpoint();
  const [expandedIndex, setExpandedIndex] = useState(0);
  const [activeTab, setActiveTab] = useState(0);

  const toggleAccordion = (index) => {
    setExpandedIndex(expandedIndex === index ? -1 : index);
  };

  return (
    <div className="container services">
      <div className="services__title-container">
        <h2 className="services__title">My Popular Services</h2>
        <hr />
        Services are offered for both residential and commercial properties.
      </div>
      {isMaxWidth("tablet") ? (
        <div className="chakra-accordion">
          {services.map((service, index) => (
            <div key={service.title}>
              <button
                className="chakra-accordion__button"
                onClick={() => toggleAccordion(index)}
              >
                <h3>{service.title}</h3>
                {expandedIndex === index ? (
                  <FiMinus className="chakra-icon" />
                ) : (
                  <FiPlus className="chakra-icon" />
                )}
              </button>
              {expandedIndex === index && (
                <div style={{ paddingBottom: "1rem" }}>
                  <div className="services__panel-content">
                    <div className="services__panel-image-container">
                      <img src={service.image} alt={service.title} />
                    </div>
                    <div className="services__panel-description-container">
                      <div className="services__panel-description">
                        {service.description}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="chakra-tabs">
          <div className="chakra-tabs__tablist" role="tablist">
            {services.map((service, index) => (
              <button
                key={service.title}
                className="chakra-tabs__tab"
                role="tab"
                aria-selected={activeTab === index}
                onClick={() => setActiveTab(index)}
              >
                {service.title}
              </button>
            ))}
          </div>
          <div>
            {services.map((service, index) =>
              activeTab === index ? (
                <div
                  key={service.title}
                  className="chakra-tabs__tab-panel"
                  role="tabpanel"
                >
                  <div className="services__panel-content">
                    <div className="services__panel-image-container">
                      <img src={service.image} alt={service.title} />
                    </div>
                    <div className="services__panel-description-container">
                      <h3 className="services__panel-title">
                        {service.title}
                      </h3>
                      <div className="services__panel-description">
                        {service.description}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null
            )}
          </div>
        </div>
      )}
    </div>
  );
};
